import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AccountRepository } from '@timechef/features/account/state';
import { Observable } from 'rxjs';
import { DefaultLanguage } from '.';

@Injectable()
export class AcceptLanguageInterceptor implements HttpInterceptor {
  constructor(private accountRepo: AccountRepository) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    request = request.clone({ setHeaders: { 'Accept-Language': this.accountRepo.getLanguage() || DefaultLanguage } });
    return next.handle(request);
  }
}
